import { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getServiceById, getProjectsForService } from '../utils/dataModel';
import SEO from './SEO';

const ServicePage = () => {
  const { serviceId } = useParams();
  const service = getServiceById(serviceId);
  const projects = getProjectsForService(serviceId);

  // Reset scroll to top when component mounts or serviceId changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [serviceId]);

  if (!service) {
    return (
      <div className="service-page not-found">
        <div className="container">
          <h1>Service Not Found</h1>
          <p>The service you're looking for doesn't exist.</p>
          <Link to="/" className="btn-primary">Return Home</Link>
        </div>
      </div>
    );
  }

  const seoTitle = `${service.title} | SolidlyAI`;
  const seoDescription = service.description;

  return (
    <>
      <SEO 
        title={seoTitle}
        description={seoDescription}
        type="article"
      />
      
      <div className="service-page">
        <div className="service-header">
          <div className="container">
            <div className="project-breadcrumb">
              <Link to="/">Home</Link>
              <span> / </span>
              <span>{service.title}</span>
            </div>
            
            <div className="service-header-content">
              <div className="service-image-large">
                <img 
                  src={service.image} 
                  alt={`${service.title} service`}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
                <div className="service-icon-fallback" style={{display: 'none'}}>{service.icon}</div>
              </div>
              <h1>{service.title}</h1>
              <p className="service-description-large">{service.description}</p>
            </div>
          </div>
        </div>

        <div className="service-content">
          <div className="container">
            <section className="service-features">
              <h2>What We Deliver</h2>
              <ul className="features-list">
                {service.features.map((feature, index) => (
                  <li key={index} className="feature-item">
                    <span className="feature-icon">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
            </section>

            <section className="service-projects">
              <h2>Featured Projects</h2>
              <div className="projects-grid">
                {projects.map((project) => (
                  <Link 
                    to={`/projects/${project.id}`} 
                    key={project.id} 
                    className="project-card-link"
                  >
                    <div className="project-card">
                      <div className="project-logo">
                        <img 
                          src={project.logo} 
                          alt={`${project.client_name} logo`}
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'block';
                          }}
                        />
                        <div className="project-icon" style={{display: 'none'}}>{project.icon}</div>
                      </div>
                      <h3>{project.title}</h3>
                      <p className="project-client">{project.client_name}</p>
                      <p className="project-summary">{project.problem_statement}</p>
                      <span className="project-link-text">View project →</span>
                    </div>
                  </Link>
                ))}
              </div>
            </section>

            <section className="service-cta">
              <div className="cta-content">
                <h2>Ready to Get Started?</h2>
                <p>Let's discuss how {service.title.toLowerCase()} can drive your business forward.</p>
                <Link to="/#contact" className="btn btn-primary">Start a Conversation</Link>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServicePage;